import {
  getFirestore,
  initializeFirestore,
  memoryLocalCache,
  persistentLocalCache,
  persistentMultipleTabManager,
} from 'firebase/firestore';

function getDefaultBrowserEnv() {
  return typeof window !== 'undefined' ? window : {};
}

export function isWebKitMobileBrowser(env = getDefaultBrowserEnv()) {
  const navigator = env?.navigator || {};
  const userAgent = navigator.userAgent || '';
  const platform = navigator.platform || '';
  return /iPad|iPhone|iPod/.test(userAgent)
    || (platform === 'MacIntel' && Number(navigator.maxTouchPoints || 0) > 1);
}

export function isWebKitBrowser(env = getDefaultBrowserEnv()) {
  const navigator = env?.navigator || {};
  const userAgent = navigator.userAgent || '';
  const isAppleWebKit = /AppleWebKit/i.test(userAgent);
  const isChromiumLike = /Chrome|CriOS|Chromium|Edg|OPR|FxiOS/i.test(userAgent);
  return isAppleWebKit && !isChromiumLike;
}

export function createPersistentFirestore(app, api = {
  getFirestore,
  initializeFirestore,
  memoryLocalCache,
  persistentLocalCache,
  persistentMultipleTabManager,
}, env = getDefaultBrowserEnv()) {
  try {
    const isWebKit = isWebKitBrowser(env);
    const localCache = isWebKit
      ? api.memoryLocalCache()
      : api.persistentLocalCache({
        tabManager: api.persistentMultipleTabManager(),
      });
    // Firebase 12.x can corrupt Firestore's shared async queue (ca9/b815) while
    // auto-detecting long polling. Normal Chromium clients do not need an
    // experimental transport override; Safari keeps the existing workaround.
    const transportSettings = isWebKit
      ? { experimentalForceLongPolling: true }
      : {};

    return api.initializeFirestore(app, {
      localCache,
      ...transportSettings,
      useFetchStreams: false,
    });
  } catch (err) {
    return api.getFirestore(app);
  }
}

export function isFirestoreClientOfflineError(error) {
  const code = String(error?.code || '').toLowerCase();
  const message = String(error?.message || error || '').toLowerCase();
  return code === 'unavailable' && message.includes('client is offline');
}
